import * as types from '../mutation-type'
import service from '@/services'
import { storage } from '@/utils'

// state
const state = {
  userInfo: (storage.getItem('u') && JSON.parse(storage.getItem('u'))) || {}
}

// getters
const getters = {
  currentUser: state => state.userInfo
}

// actions
const actions = {
  userLogin: ({commit}, payload) => {
    return service.userLogin(commit, payload, types.USER_LOGIN)
  },
  loginOut: ({commit}, payload) => {
    return service.loginOut(commit, payload, types.USER_LOGIN_OUT)
  },
  applyAddorupdate: ({commit}, payload) => {
    return service.applyAddorupdate(commit, payload)
  },
  queryPartnerListToShowByName: ({commit}, payload) => {
    return service.queryPartnerListToShowByName(commit, payload)
  },
  applyCustomer: ({commit}, payload) => {
    return service.applyCustomer(commit, payload, types.CUSTOMER_LOGIN)
  },
  loginEncryptionPortal: ({commit}, payload) => {
    return service.loginEncryptionPortal(commit, payload, types.USER_LOGIN)
  },
  updatePwd: ({commit}, payload) => {
    return service.updatePwd(commit, payload, types.USER_LOGIN)
  }
}

// mutations
const mutations = {
  [types.USER_LOGIN] (state, data) {
    console.log(data)
    // let {token, customer} = data
    let {dto} = data
    state.userInfo = dto
    // storage.setItem('t', token)
    storage.setItem('u', JSON.stringify(dto))
  },
  [types.CUSTOMER_LOGIN] (state, data) {
    console.log(data)
    // let {token, customer} = data
    let dto = data.dtoList[0]
    state.userInfo = dto
    // storage.setItem('t', token)
    storage.setItem('u', JSON.stringify(dto))
  },
  [types.USER_LOGIN_OUT] (state) {
    storage.clear()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js